// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"cfa494b5","703":"cfa494b5"}[chunkId] + ".chunk.css";
};